export enum AnnexedParameters {
  MODEL_DATE_EFFECT = 1,
  FH_EFFECT = 2,
  HIGH_CONDITIONED = 3,
  SUBROGATION = 4,
  REJECTION_REASON = 5,
  TOLL = 6,
  Q_DIARY = 7,
  TELMEASURE = 8,
  ANNUAL_CONSUMPTION = 9,
  FH_LAST_INSPECTION = 10,
  RES_LAST_INSPECTION = 11,
  CODE_ATR = 12,
  Q_SCHEDULE = 13,
  PRESSURE_SOLICITED = 14,
  USE_GAS = 15,
  PROPERTY_COUNTER = 16,
  APPARATUS_TRANSFORMATION = 17,
  NUM_APPARATUS_TRANSFORM = 18,
  COMMENTS = 19,
  INDIVIDUAL_NOMINATION = 20,
  RED_UBICATION = 21,
  SUPPLY_STATUS = 22,
  REJECT_DESCRIPTION = 23,
  HABITUAL_HOUSING = 24,
  VISIT_NUMBER = 25,
  ANSWER_INCIDENCE = 26,
  CONTACT_NAME = 27,
  PHONE_CONTACT = 28,
  MAIL_CONTACT = 29,
  NUMBER_BOE = 30,
  QD_HIRED = 31,
  QD_APPLIED = 32,
  QD_MAX = 33,
  INCENTIVES_ER_COG_Y_RES = 34,
  COSTS_DIST_Y_TRANS = 35,
  OTHER_REGULATED_COSTS = 36
}
